
import SlotMap from '@neumatter/slot-map'
import Locale from './Locale.js'

export default class DateFormat {
  constructor (locales, options) {
    options = options === undefined ? {} : options
    const opts = { timeZone: 'UTC' }

    if (locales === undefined) {
      locales = Locale.systemLocale.baseName
    } else if (Locale.isLocale(locales)) {
      locales = String(locales)
    }

    if ('calendar' in options) {
      opts.calendar = options.calendar
    }

    if ('dateStyle' in options) {
      opts.dateStyle = options.dateStyle
    } else {
      opts.year = 'numeric'
      opts.month = 'numeric'
      opts.day = 'numeric'

      if ('year' in options) {
        opts.year = options.year
      }

      if ('month' in options) {
        opts.month = options.month
      }

      if ('day' in options) {
        opts.day = options.day
      }

      if ('weekday' in options) {
        opts.weekday = options.weekday
      }

      if ('dayPeriod' in options) {
        opts.dayPeriod = options.dayPeriod
      }

      if ('era' in options) {
        opts.era = options.era
      }
    }

    const formatter = new Intl.DateTimeFormat(locales, opts)
    const resolvedOptions = formatter.resolvedOptions()
    const clonedResolved = Object.assign({}, resolvedOptions)

    for (const prop in clonedResolved) {
      if (!Object.hasOwn(opts, prop)) {
        delete clonedResolved[prop]
      }
    }

    const slotMap = SlotMap.get(this)
    slotMap.set('options', clonedResolved)
    slotMap.set('formatter', formatter)
  }

  format (date) {
    const { year, month, day } = date.getISOFields()
    const legacyDate = new Date(year, month - 1, day)
    return SlotMap.getInternal(this, 'formatter').format(legacyDate.valueOf())
  }

  formatToParts (date) {
    const { year, month, day } = date.getISOFields()
    const legacyDate = new Date(year, month - 1, day)
    return SlotMap.getInternal(this, 'formatter').formatToParts(legacyDate.valueOf())
  }

  formatRange (a, b) {
    a = a.getISOFields()
    b = b.getISOFields()
    const aDate = new Date(a.year, a.month - 1, a.day)
    const bDate = new Date(b.year, b.month - 1, b.day)
    return SlotMap.getInternal(this, 'formatter').formatRange(aDate.valueOf(), bDate.valueOf())
  }

  formatRangeToParts (a, b) {
    a = a.getISOFields()
    b = b.getISOFields()
    const aDate = new Date(a.year, a.month - 1, a.day)
    const bDate = new Date(b.year, b.month - 1, b.day)
    return SlotMap.getInternal(this, 'formatter').formatRangeToParts(aDate.valueOf(), bDate.valueOf())
  }

  resolvedOptions () {
    return SlotMap.getInternal(this, 'formatter').resolvedOptions()
  }
}
